import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-zinc-200 bg-white" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 klein-bg rounded-sm flex items-center justify-center">
              <span className="font-display text-white font-bold text-sm">F</span>
            </div>
            <span className="font-display font-semibold tracking-tight text-lg">FlowMind AI</span>
          </div>
          <p className="text-sm text-zinc-600 max-w-sm leading-relaxed">
            La plateforme no-code d'automatisation pilotée par IA, conçue pour les PME européennes.
            Données hébergées en Union Européenne · RGPD compliant.
          </p>
        </div>

        <div>
          <p className="overline mb-4">Produit</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/#features" className="hover:text-black text-zinc-600">Fonctionnalités</Link></li>
            <li><Link to="/#pricing" className="hover:text-black text-zinc-600">Tarifs</Link></li>
            <li><Link to="/demo" className="hover:text-black text-zinc-600">Démo</Link></li>
            <li><Link to="/roadmap" className="hover:text-black text-zinc-600">Roadmap</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Entreprise</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/mentions-legales" className="hover:text-black text-zinc-600" data-testid="footer-mentions-link">Mentions légales</Link></li>
            <li><Link to="/privacy" className="hover:text-black text-zinc-600" data-testid="footer-privacy-link">Politique de confidentialité</Link></li>
            <li><Link to="/cgu" className="hover:text-black text-zinc-600" data-testid="footer-cgu-link">CGU & CGV</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Compte</p>
          <ul className="space-y-3 text-sm">
            <li><Link to="/login" className="hover:text-black text-zinc-600">Se connecter</Link></li>
            <li><Link to="/signup" className="hover:text-black text-zinc-600">S'inscrire</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} FlowMind AI · Société basée en Union Européenne</p>
          <p className="text-xs text-zinc-500 font-mono">v1.0 · EU-WEST-3 · PARIS</p>
        </div>
      </div>
    </footer>
  );
}
